export const funnelCopy = {
  role: {
    title: "What sort of job is it?",
    intro: "Pick the role that matches this job. We'll use it to set the right CDM duties.",
    options: [
      {
        value: "RUNNING_THE_JOB",
        title: "I'm running this job",
        body: "Use this when you are acting as the main contractor or coordinating the work.",
      },
      {
        value: "SOLO_TRADER",
        title: "It's just me or my team",
        body: "Use this for smaller jobs where you still need proper RAMS, CPP and site records.",
      },
      {
        value: "SOMEONE_ELSES_JOB",
        title: "I'm working on someone else's job",
        body: "Use this when you need documents for your part of a wider project.",
      },
    ],
    continue: "Continue to the job details",
  },
  brief: {
    title: "Add the job details",
    intro: "Fill this in yourself, or upload a PDF and check what we find.",
    save: "Save this project",
    fields: {
      title: {
        label: "Project name",
        why: "This becomes the heading on your project workspace and document pack.",
      },
      siteAddress: {
        label: "Site address",
        why: "The site address appears on the CPP, RAMS and induction records.",
      },
      domesticClient: {
        label: "Is this someone's home?",
        why: "Domestic work changes how CDM duties are assigned.",
      },
      estimatedDuration: {
        label: "Estimated duration",
        why: "Duration helps shape the CPP timeline and site controls.",
      },
      scopeDescription: {
        label: "What work are you doing?",
        why: "The scope drives hazards, method statements and the first document outline.",
      },
    },
  },
  progress: {
    shell: "Project shell created",
    site: "Site details captured",
    domestic: "Domestic/non-domestic logic applied",
    structure: "Initial CPP structure preparing",
    hazards: "Hazard suggestions preparing",
  },
  save: {
    title: "Create your account to save",
    intro: "Set up your login and we will keep this draft ready on any device.",
    cta: "Email yourself the link to keep going",
  },
} as const;

